module.exports = __webpack_public_path__ + "static/media/water_300_detail_01.8e8d72a7.jpg";